<template>
  <h4>
    <span>{{ title }}</span>
    <slot></slot>
  </h4>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
  h4 {
    padding-bottom: px2rem(10px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: px2rem(16px);
    line-height: px2rem(24px);
  }
</style>



// WEBPACK FOOTER //
// src/components/TitleM.vue